import config from "../assets/config";
export const util = {
  methods: {
    async getEspacioUtilizado(entidad) {
      if (entidad) {
        try {
          let promArchivos = this.$axios.get(config.pathDiscoArchivos);
          let promDb = this.$axios.get(config.pathDiscoDB + entidad);
          let [resArchivos, resDb] = await Promise.all([promArchivos, promDb]);
          let espacio_archivos = resArchivos.data.info[0].disco_utilizado_archivos;
          let espacio_db = resDb.data.info[0].disco_utilizado_db;
          return parseFloat(espacio_db) + parseFloat(espacio_archivos);
        } catch (error) {
          return 0;
        }
      }
    },
  },
};
